module.exports = __webpack_public_path__ + "static/img/homeBg.a9670ee5.png";